// @flow
import { Map, Set } from "immutable"

import type Place from "common/records/Place"
import { fetchLocationPlaceId } from "common/services/locations/locationsApi"
import Flight from "common/records/Flight"

type Props = {
  url: string,
  locale: string,
  flights: Array<Flight>,
  cacheOnly?: boolean,
}

const cache = {}

async function loadMissingFlightsPlacesNames({
  url,
  flights,
  locale,
  cacheOnly = false,
}: Props): Promise<Map<string, Place>> {
  const promises = flights
    .reduce((acc: Set, flight: Flight) => acc.add(flight.src).add(flight.dst), new Set())
    // $FlowIssue
    .map(async placeId => {
      const key = `${url}_${locale}_${placeId}`
      if (!cacheOnly && !cache[key]) {
        cache[key] = await fetchLocationPlaceId(url, locale, placeId)
      }
      return cache[key]
    })

  const places = await Promise.all(promises)
  return places.reduce(
    (acc, place: Place) => (place ? acc.set(place.get("id"), place) : acc),
    Map(),
  )
}

export default loadMissingFlightsPlacesNames
